/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_1_BodyInputs */

const en_about_principle_1_body = /** @type {(inputs: About_Principle_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We ask how the work happens, what your team trusts and where the exceptions live. The answers shape what gets built.`)
};

const lv_about_principle_1_body = /** @type {(inputs: About_Principle_1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jautājam, kā notiek darbs, kam komanda uzticas un kādi ir izņēmuma gadījumi. Atbildes nosaka, kādu sistēmu veidojam.`)
};

/**
* | output |
* | --- |
* | "We ask how the work happens, what your team trusts and where the exceptions live. The answers shape what gets built." |
*
* @param {About_Principle_1_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_1_body = /** @type {((inputs?: About_Principle_1_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_1_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_1_body(inputs)
	return en_about_principle_1_body(inputs)
});